
import React, { useEffect, useState } from 'react';
import { Box,} from '@mui/material';
import { ClinicInfoFormData, ClinicListResponse, getClinicList } from '../../../components/ClinicConfiguration/clinicHelper';
import ClinicListHeader from '../../../components/ClinicConfiguration/ClinicListHeader';
import ClinicTable from '../../../components/ClinicConfiguration/ClinicTable';
// import ClinicAddEditInfoForm from '../../../components/ClinicConfiguration/ClinicAddEditInfoForm';
import { useNavigate } from 'react-router-dom';
import ViewClinicDetails from '../../../components/ClinicConfiguration/ViewClinicDetails';
import ClinicAddEditInfoForm from '../../../components/ClinicConfiguration/ClinicAddEditInfoForm';
import CustomPagination from '../../cryoStorage/customPagination';



const ClinicConfig: React.FC = () => {
  const [clinicList, setClinicList] = useState<ClinicInfoFormData[]>();
  const [searchInput, setSearchInput] = useState('');
  const [debouncedSearch, setDebouncedSearch] = useState('');
  const navigate = useNavigate();
  const [isAdding, setIsAdding] = useState(false);
  const [isView, setIsView] = useState(false);
  const [viewClinicId, setViewClinicId] = useState<number  | null>(null);
  const [page, setPage] = useState(0);
  const [rowsPerPage] = useState(10);
  const [totalCount, setTotalCount] = useState(0);

  const offset = page * rowsPerPage;

  useEffect(() => {
    const handle = setTimeout(() => {
      setDebouncedSearch(searchInput.trim());
    }, 300);
    return () => clearTimeout(handle);
  }, [searchInput]);

  useEffect(() => {
    getClinicList(debouncedSearch, rowsPerPage, offset)
      .then((response: ClinicListResponse) => {
        setClinicList(response.objects);
        setTotalCount(response.meta?.total_count ?? response.objects?.length ?? 0);
      })
      .catch((err) => {
        // eslint-disable-next-line no-console
        console.error('Error fetching clinics', err);
      });
  }, [debouncedSearch, rowsPerPage, offset]);

  const handleEdit = (clinic: ClinicInfoFormData) => {
    if (clinic && clinic.id) {
      navigate(`/ai/configuration/clinic/${clinic.id}`);
    }
  };

  const handleView = (clinic: ClinicInfoFormData) => {
    if (clinic && clinic.id) {
      setViewClinicId(clinic.id);
      setIsView(true);
    }
  };

  const handlePageChange = (_: React.ChangeEvent<unknown>, newPage: number) => {
    setPage(newPage);
  };

  const handleSearchChange = (val: string) => {
    setSearchInput(val);
    setPage(0);
  };

  const handleCreate = () => {
    setIsAdding(true);
  };

  return (
    <Box p={3}>
      {isView ? (
        <ViewClinicDetails id={viewClinicId} onBack={() => setIsView(false)} />
      ) : isAdding ? (
        <ClinicAddEditInfoForm onCancel={() => setIsAdding(false)} />
      ) : (
        <>
          <ClinicListHeader
            search={searchInput}
            onSearchChange={handleSearchChange}
            onCreate={handleCreate}
          />
          <ClinicTable clinics={clinicList ?? []}  onEdit={handleEdit} onView={handleView} />
          <Box mt={1}>
            <CustomPagination
              page={page}
              pageSize={rowsPerPage}
              totalCount={totalCount}
              onPageChange={handlePageChange}
            />
          </Box>
        </>
      )}
    </Box>
  );
};

export default ClinicConfig;
